import React, { useEffect } from 'react';

import BeefreeSDK, { beeTypes } from '@beefree.io/sdk';

import ptBr from '../../resources/languages/pt-br.json';
import { Container } from './styles';

import { getBeeToken } from '~/services/bee';

const ShowCase = () => {
  const apiURL = process.env.REACT_APP_API_URL;
  const beeConfig: beeTypes.IBeeConfig = {
    uid: 'uid_15998',
    container: 'bee-container',
    autosave: 0,
    language: 'pt-BR',
    preventClose: false,
    trackChanges: true,
    rowsConfiguration: {
      defaultRows: true,
      emptyRows: false,
      externalContentURLs: [
        {
          name: 'Formulário Estático',
          value: `${apiURL}/rows`
        }
      ]
    }
    // defaultForm: {
    //   structure: {
    //     fields: {
    //       email: {
    //         type: 'email',
    //         label: 'E-mail',
    //         canBeRemovedFromLayout: false,
    //         attributes: {
    //           name: 'email',
    //           required: true,
    //           placeholder: 'Seu melhor e-mail'
    //         }
    //       },
    //       name: {
    //         type: 'text',
    //         label: 'Nome',
    //         removeFromLayout: false,
    //         canBeRemovedFromLayout: true,
    //         attributes: {
    //           name: 'name',
    //           placeholder: 'Seu nome'
    //         }
    //       },
    //       daysLabel: {
    //         type: 'label',
    //         label: 'Choose a day'
    //       },
    //       monday: {
    //         type: 'checkbox',
    //         label: 'Monday',
    //         attributes: {
    //           name: 'preferredDays'
    //         }
    //       },
    //       tuesday: {
    //         type: 'checkbox',
    //         label: 'Tuesday',
    //         attributes: {
    //           name: 'preferredDays'
    //         }
    //       },
    //       wednesday: {
    //         type: 'checkbox',
    //         label: 'Wednesday',
    //         attributes: {
    //           name: 'preferredDays'
    //         }
    //       },
    //       thursday: {
    //         type: 'checkbox',
    //         label: 'Thursday',
    //         attributes: {
    //           name: 'preferredDays'
    //         }
    //       },
    //       friday: {
    //         type: 'checkbox',
    //         label: 'Friday',
    //         attributes: {
    //           name: 'preferredDays'
    //         }
    //       },
    //       saturday: {
    //         type: 'checkbox',
    //         label: 'Saturday',
    //         attributes: {
    //           name: 'preferredDays'
    //         }
    //       },
    //       submit_button: {
    //         type: 'submit',
    //         label: '',
    //         attributes: {
    //           value: 'SEND DATA',
    //           name: 'submit_button'
    //         }
    //       }
    //     },
    //     layout: [
    //       ['email'],
    //       ['name'],
    //       ['daysLabel'],
    //       ['monday', 'tuesday', 'wednesday'],
    //       ['thursday', 'friday', 'saturday'],
    //       ['submit_button']
    //     ],
    //     attributes: {
    //       action: '/capture',
    //       method: 'post',
    //       target: '_self',
    //       autocomplete: 'off'
    //     },
    //     title: 'static',
    //     description: 'Showcase static form'
    //   }
    // }
  };

  useEffect(() => {
    async function load() {
      const userUid = 'bee-leadlovers-uid-15998';

      try {
        const tokenResponse = await getBeeToken(userUid);

        if (!tokenResponse) {
          console.error('Failed to get Bee token');
          return;
        }

        const bee = new BeefreeSDK(tokenResponse);
        const templateResponse = await fetch(
          '/resources/templates/base-blank.json'
        );
        const template = await templateResponse.json();
        bee.start(beeConfig, template);
      } catch (error) {
        console.error(error);
      }
    }
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <div id="bee-container" />
    </Container>
  );
};

export default ShowCase;
